import { Animated } from 'react-native';
import Box from '../../../Box/Box';
import { SliderDotsProps } from './SliderDots.types';

function SliderDots({
  itemsCount,
  activeIndex,
  dotWidths,
  activeDotColor = '#FFFFFF',
  inactiveDotColor = '#FFFFFF4D',
  positioning = {
    bottom: '-space-1000',
    left: 'space-0',
    right: 'space-0',
  },
  backgroundColor = 'bgOverlayDarkScrimBackground',
}: SliderDotsProps) {
  if (itemsCount <= 1) {
    return null;
  }

  return (
    <Box
      position="absolute"
      bottom={positioning.bottom}
      left={positioning.left}
      right={positioning.right}
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      paddingVertical="space-300"
    >
      <Box
        flexDirection="row"
        alignItems="center"
        gap="space-200"
        paddingVertical="space-200"
        paddingHorizontal="space-300"
        borderRadius="radius-full"
        backgroundColor={backgroundColor}
      >
        {Array.from({ length: itemsCount }).map((_, index) => (
          <Animated.View
            key={index}
            style={{
              height: 6,
              width: dotWidths[index],
              borderRadius: 3,
              backgroundColor:
                index === activeIndex ? activeDotColor : inactiveDotColor,
            }}
          />
        ))}
      </Box>
    </Box>
  );
}

export default SliderDots;